// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3flFG","requiredAsterisk":"Info_requiredAsterisk__y0oIU"};